module.exports = __webpack_public_path__ + "img/224-Veka Spectral 6009-Vert Sapin.png";